<template>
    <div>
        <div class="composer__ttl composer__ttl--secondary">
            <h3>Content</h3>
        </div>
        <app-draggable :list="sections" @change="repositionFixedItems" :options="{draggable:'.section', filter:'.ignore-elements', handle:'.sectionHandle', group:'sections'}" class="p-8" style="min-height: 6rem">
            <div v-if="sections.length > 0" v-for="(section, sectionIndex) in sections" :class="'composer__section section shadow ' + (typeof section.settings.fixed != 'undefined' && section.settings.fixed.isFixed ? 'ignore-elements' : '')" :key="sectionIndex">
                <!-- Toolbar -->
                <div class="composer__toolbar sectionHandle">
                    <div>
                        <h3 class="text-black" v-html="section.settings.name && section.settings.name.length > 0 ? section.settings.name : 'Section ' + (sectionIndex+1)"></h3>
                    </div>
                    <div class="ml-auto fs0">
                        <a href="javascript:void(0)" @click="selectSection(section, sectionIndex)" v-if="checkPermissions(typeof section.settings.controls != 'undefined' && typeof section.settings.controls.settingsOpen != 'undefined' ? section.settings.controls.settingsOpen : true)"><app-icon icon="cog" /></a>
                        <a href="javascript:void(0)" @click="addRow(sectionIndex)" v-if="checkPermissions(typeof section.settings.controls != 'undefined' && typeof section.settings.controls.addRow != 'undefined' ? section.settings.controls.addRow : true)"><app-icon icon="plus" /></a>
                        <a href="javascript:void(0)" class="del" @click="deleteSection(sectionIndex)" v-if="checkPermissions(typeof section.settings.controls != 'undefined' && typeof section.settings.controls.delete != 'undefined' ? section.settings.controls.delete : true)"><app-icon icon="times" /></a>

                        <a href="javascript:void(0)" @click="section.open = !section.open" v-if="checkPermissions(typeof section.settings.controls != 'undefined' && typeof section.settings.controls.collapse != 'undefined' ? section.settings.controls.collapse : true)">
                            <app-icon :icon="section.open ? 'angle-down' : 'angle-right'" />
                        </a>
                    </div>
                </div>
                <div class="composer__item" v-if="section.open">
                    <app-draggable :list="section.rows" :options="{draggable:'.row', handle:'.rowhandle', group:'rows'}" style="min-height: 6rem">
                        <div v-for="(row, rowIndex) in section.rows" :key="rowIndex" class="composer__section row">
                            <!-- Toolbar -->
                            <div class="composer__toolbar rowhandle">
                                <div>
                                    <h3 class="text-black" v-html="'Row ' + (rowIndex+1)"></h3>
                                </div>
                                <div class="ml-auto fs0">
                                    <a href="javascript:void(0)" @click="selectRow(row, sectionIndex, rowIndex)" ><app-icon icon="cog" /></a>
                                    <a href="javascript:void(0)" @click="addColumn(sectionIndex, rowIndex)"><app-icon icon="plus" /></a>
                                    <a href="javascript:void(0)" class="del" @click="deleteRow(sectionIndex, rowIndex)"><app-icon icon="times" /></a>

                                    <a href="javascript:void(0)" @click="row.open = !row.open">
                                        <app-icon :icon="row.open ? 'angle-down' : 'angle-right'" />
                                    </a>
                                </div>
                            </div>
                            <div class="composer__item" v-if="row.open">
                                <app-draggable :list="row.columns" :options="{draggable:'.column', handle:'.colHandle', group:'columns'}" class="flex flex-wrap -mx-2" style="min-height: 6rem">
                                    <div v-for="(column, colIndex) in row.columns" :key="colIndex" class="column px-2" v-bind:class="['sm:' + column.settings.responsive.sm.width, 'md:' + sections[sectionIndex].rows[rowIndex].columns[colIndex].settings.responsive.md.width, 'lg:' + sections[sectionIndex].rows[rowIndex].columns[colIndex].settings.responsive.lg.width, 'xl:' + sections[sectionIndex].rows[rowIndex].columns[colIndex].settings.responsive.xl.width, sections[sectionIndex].rows[rowIndex].columns[colIndex].settings.responsive.default.width]">
                                        <div class="composer__section">
                                            <!-- Toolbar -->
                                            <div class="composer__toolbar colHandle">
                                                <div>
                                                    <h3 class="text-black">Column</h3>
                                                </div>
                                                <div class="ml-auto fs0">
                                                    <a href="javascript:void(0)" @click="selectColumn(column, sectionIndex, rowIndex, colIndex)" ><app-icon icon="cog" /></a>
                                                    <a href="javascript:void(0)" class="del" @click="deleteColumn(sectionIndex, rowIndex, colIndex)"><app-icon icon="times" /></a>
                                                </div>
                                            </div>
                                            <div class="w-full composer__item">
                                                <app-draggable :list="column.elements" :options="{draggable:'.element', handle:'.elHandle', group:'elements'}" class="flex flex-wrap" style="min-height: 6rem">
                                                    <div v-for="(element, elIndex) in column.elements" :key="elIndex" class="composer__section elHandle element w-full">
                                                        <div class="composer__section__element">
                                                            <div class="composer__section__element__toolbar shadow-lg py-2 px-4" style="background: #f4f4f4;">
                                                                <a href="javascript:void(0)" @click="selectElement(element, sectionIndex, rowIndex, colIndex, elIndex)"><app-icon icon="cog" /></a>
                                                                <a href="javascript:void(0)" class="del" @click="deleteElement(sectionIndex, rowIndex, colIndex, elIndex)"><app-icon icon="times" /></a>
                                                            </div>

                                                            <!-- <span class="icon" v-if="element.icon"><i :class="element.icon"></i></span> <div class="inline-block" v-html="element.display && typeof element.values[element.display] !== 'undefined' && element.values[element.display] !== '' ? element.values[element.display] : element.name"></div> -->
                                                            <span class="icon" v-if="element.icon"><app-icon :icon="element.icon" /></span> <div class="inline-block" v-html="element.name"></div>
                                                        </div>
                                                    </div>
                                                </app-draggable>
                                            </div>
                                        </div>
                                    </div>
                                </app-draggable>
                            </div>
                        </div>
                    </app-draggable>
                </div>
            </div>
        </app-draggable>
    </div>
</template>

<style>
    .fs0 {
        font-size: 0;
    }

    .composer__toolbar {
        @apply .cursor-move .py-4 .px-6 .pr-0 .w-full .text-white .flex .items-center;

        background: #f4f4f4;
        border-bottom: 1px solid #eaeaea;
    }

    .composer__toolbar a {
        @apply .text-grey-darkest .text-xl .p-4;

        border-left: 1px solid #eaeaea;

        transition: all 0.2s ease-in-out;
    }

    .composer__toolbar a:hover {
        @apply .bg-blue .text-white;
    }

    .composer__toolbar a.del {
        @apply .text-red;
    }

    .composer__toolbar a.del:hover {
        @apply .text-white;
    }

    .composer__section {
        @apply .mb-6;

        border: 1px solid #eaeaea;
    }

    .composer__section__element {
        @apply .relative .p-6 .text-center .text-lg;

        border: 1px solid #eaeaea;
    }

    .composer__section__element .icon {
        @apply .mr-2;
    }

    .composer__section__element__toolbar {
        @apply .hidden .absolute;

        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
    }

    .composer__section__element__toolbar a {
        @apply .text-grey-darkest .no-underline .text-xl .px-2;
    }

    .composer__section__element__toolbar a.del {
        @apply .text-red;
    }

    .composer__section__element:hover .composer__section__element__toolbar {
        @apply .block;
    }

    .composer__toolbar h1, .composer__toolbar h2, .composer__toolbar h3, .composer__toolbar h4, .composer__toolbar h5, .composer__toolbar h6 {
        @apply .text-base;
    }

    .composer__ttl--secondary {
        @apply .bg-grey-darkest;
    }

    .composer__item {
        @apply .p-6
    }
</style>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        'app-draggable': draggable
    },
    props: {
        sections: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        loading: false,
    }),

    methods: {
        checkPermissions: function(bool) {
            return bool;
        },
        repositionFixedItems() {
            this.$emit('repositionFixedItems');
        },
        selectSection(section, sectionIndex) {
            this.$emit('selected', {
                type: 'section',
                object: section,
                indexes: {
                    section: sectionIndex
                }
            })
        },
        selectRow(row, sectionIndex, rowIndex) {
            this.$emit('selected', {
                type: 'row',
                object: row,
                indexes: {
                    section: sectionIndex,
                    row: rowIndex
                }
            })
        },
        selectColumn(column, sectionIndex, rowIndex, colIndex) {
            this.$emit('selected', {
                type: 'column',
                object: column,
                indexes: {
                    section: sectionIndex,
                    row: rowIndex,
                    column: colIndex
                }
            })
        },
        selectElement(element, sectionIndex, rowIndex, colIndex, elIndex) {
            this.$emit('selected', {
                type: 'element',
                object: element,
                indexes: {
                    section: sectionIndex,
                    row: rowIndex,
                    column: colIndex,
                    element: elIndex
                }
            })
        },

        addRow(sectionIndex) {
            this.$emit('addRow', sectionIndex)
        },
        addColumn(sectionIndex, rowIndex) {
            this.$emit('addColumn', sectionIndex, rowIndex)
        },

        deleteSection(sectionIndex) {
            this.$emit('deleteSection', sectionIndex)
        },
        deleteRow(sectionIndex, rowIndex) {
            this.$emit('deleteRow', sectionIndex, rowIndex)
        },
        deleteColumn(sectionIndex, rowIndex, colIndex) {
            this.$emit('deleteColumn', sectionIndex, rowIndex, colIndex)
        },
        deleteElement(sectionIndex, rowIndex, colIndex, elIndex) {
            this.$emit('deleteElement', sectionIndex, rowIndex, colIndex, elIndex)
        }
    },

    computed: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/composer/Playground.vue